import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import NRTVerticalStack from "../../../../../../../../components/_common/_containers/VerticalStack/index"
import NRTFormInput from "../../../../../../../../components/_common/_form/FormInput/index"
import ButtonWithChevron from "../../../../../../../../components/_minha-central/ButtonWithChevron/index"
import NRTFormStateManager from "../../../../../../../../components/_common/_form/FormStateManager/index"
import {Validators} from "../../../../../../../../components/_common/_form/Validators/index"
import moment from "moment"
import {getS3Key} from "../../../../../../../../helpers/aws"
import FileRequests from "../../../../../../../../requests/file-requests"
import MCEadInputLabel from "../../../../../../../../components/_ead/InputLabel/index"
import MCEadContentCard from "../../../../../../../../components/_ead/ContentCard/index"
import PersonRequests from "../../../../../../../../requests/person-requests"
import MCLoadingOverlay from "../../../../../../../../components/_minha-central/LoadingOverlay/index"

//import './style.css'

const SIMULATE_UPLOAD_ERROR = false

class EadTalkToInstructorPage extends Component {


    state = {
        awaiting: false,
        form: {},
        instructorsOptions: []
    }


    static getDerivedStateFromProps(nextProps) {
        return {
            release: _.get(nextProps, 'context.eadRelease'),
            person: _.get(nextProps, 'context.person'),
            schema: _.get(nextProps, 'context.credentials.schema'),
        }
    }


    componentDidMount() {
        const {
            release,
        } = this.state


        const instructorsOptions = release.personOwnerDTOs ? release.personOwnerDTOs.map(dto => ({
            value: dto.code,
            label: `${dto.name} (${dto.email}) ${dto.code}`
        })) : ""

        this.setState({
            instructorsOptions
        })
    }

    fileChanged = async (formFile) => {

        const {
            release,
            person
        } = this.state


        if (formFile &&
            formFile.valid &&
            formFile.values.file
        ) {

            const fileUrl = formFile.values.file
            const fileName = decodeURIComponent(fileUrl).substring(fileUrl.lastIndexOf("/") + 1)

            const req = SIMULATE_UPLOAD_ERROR ?
                Promise.reject('SIMULATE_UPLOAD_ERROR') :
                FileRequests
                    .save({
                        category: 2, //Documentos
                        date: moment(),
                        entityClass: "br.com.nerit.entity.model.EmpProductRelease",
                        entityCode: release.code,
                        path: getS3Key(fileUrl),
                        prsCode: person.code,
                        title: fileName,
                        url: fileUrl
                    })

            req
                .then(result => {
                    if (result.success) {

                        this.props.context.set({
                            toastMessage: {
                                type: 'success',
                                content: 'Seu arquivo foi enviado com sucesso!'
                            }
                        })

                    } else {
                        this.onError('Erro ao enviar arquivo', 'Ocorreu um erro no envio do arquivo.')
                    }

                })
                .catch(error => {
                    this.onError(error, 'Ocorreu um erro no envio do arquivo.')
                })

        }
    }


    submit = async () => {

        const {
            person,
            schema,
            form,
            release
        } = this.state


        const message = form.values.message
        const code = form.values.instructorOption
        const instructor = release.personOwnerDTOs.filter(i => i.code === code)[0]

        if (!code || !message || !instructor)
            return

        await this.setState({awaiting: true})

        const dto = {
            domain: schema,
            email: instructor.email,
            emailsTo: instructor.email,
            responsibleCode: person.code,
            message: '\n' + 'Aluno: ' + person.name +
                '\n' + 'Email: ' + person.email +
                '\n' + 'Curso: ' + release.name + '\n\n' + 'Mensagem: ' + message
        }

        PersonRequests
            .addContact(dto)
            .then(result => {
                if (result.success) {
                    this.props.context.set({
                        toastMessage: {
                            type: 'success',
                            content: "Sua mensagem foi enviada para seu instrutor.",
                        }
                    })
                    this.setState({awaiting: false})
                    this.textMessage.setValue(null)
                } else
                    throw new Error(result.message)
            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro no envio da mensagem.', {msg: 'Ocorreu um erro no envio da mensagem.'})
            })
    }


    onError(error, message, data) {

        this.setState({awaiting: false})

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: message
            }
        })
        this.props.context.logError(error, data)
    }


    onFormMessageChange = (form) => this.setState({form})


    render() {


        const {
            release,
            awaiting,
            instructorsOptions
        } = this.state

        const schema = this.props.context.credentials.schema;

        return (
            <Fragment>
                <MCLoadingOverlay show={awaiting}/>

                {
                    schema !== 'rl' ? '' : <MCEadContentCard style={{minHeight: '50px'}}>Em caso de dúvidas, favor enviar e-mail para ricardo@rlassociados.com.br.</MCEadContentCard>
                }

                <MCEadContentCard style={{minHeight: '200px'}}>
                    <div style={{width: "100%"}}>
                        <NRTFormStateManager ref={f => this.formFile = f}
                                             onStateChange={this.fileChanged} debug>
                            <NRTVerticalStack>

                                <MCEadInputLabel text={'Enviar arquivo'}/>

                                <NRTFormInput
                                    name={'file'}
                                    type={'file'}
                                    customClass={'nrt-file-input-container nrt-upload-file-class'}
                                    customProps={{
                                        shouldUploadToS3: true,
                                        s3ParentType: `Versao/${release.code}/arquivos`
                                    }}
                                />
                            </NRTVerticalStack>
                        </NRTFormStateManager>
                    </div>
                </MCEadContentCard>


                <MCEadContentCard
                    style={{
                        minHeight: !!release.personOwnerDTOs ? '' : '6rem'
                    }}
                >
                    <div style={{width: "100%"}}>
                        {
                            !!release.personOwnerDTOs ? (
                                    <NRTFormStateManager ref={f => this.formMessage = f}
                                                         onStateChange={this.onFormMessageChange}>
                                        <NRTVerticalStack>

                                            <MCEadInputLabel text={'Fale com o Professor'}/>


                                            <NRTFormInput name={'instructorOption'}
                                                          label={'Selecione o Professor'}
                                                          type={'select'}
                                                          customProps={{
                                                              options: instructorsOptions
                                                          }}
                                                          validators={[
                                                              Validators.required()
                                                          ]}
                                            />

                                            <NRTFormInput
                                                ref={(input) => this.textMessage = input}
                                                type={'textarea'}
                                                name={'message'}
                                                validators={[
                                                    Validators.required()
                                                ]}
                                                customProps={{
                                                    rows: '10'
                                                }}
                                            />


                                            <ButtonWithChevron buttonLabel={'Enviar'}
                                                               secondary
                                                               onClick={this.submit}
                                                               disabled={this.state.form.valid === false}
                                                               style={{
                                                                   margin: "0 auto",
                                                                   width: "30rem"
                                                               }}
                                            />

                                        </NRTVerticalStack>
                                    </NRTFormStateManager>
                                ) :
                                (
                                    <div>
                                        <MCEadInputLabel text={'Fale com o Professor'}/>
                                        <h3 style={{
                                            textAlign: 'center',
                                            opacity: .5
                                        }}
                                        >Não existem instrutores associados a este curso no momento.
                                        </h3>
                                    </div>
                                )
                        }


                    </div>
                </MCEadContentCard>
            </Fragment>
        )
    }
}


EadTalkToInstructorPage.propTypes = {
    context: PropTypes.object.isRequired,
}

EadTalkToInstructorPage.defaultProps = {}


export default EadTalkToInstructorPage



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/TalkToInstructor/index.js